import { Injectable } from '@angular/core';
import { Converter } from '@spartacus/core';
import { Occ } from '../../../../core/occ';
import { Assortment, AssortmentTable } from '../models';

@Injectable({ providedIn: 'root' })
export class ProductAssortmentTableNormalizer implements Converter<Occ.Assortment, AssortmentTable> {
  convert(source: Occ.Assortment, target?: AssortmentTable): AssortmentTable {
    if (source) {
      const assortment: Assortment[] = [];

      (source.dimensions || []).forEach((dimension) => {
        (source.grammages || []).forEach((grammage) => {
          const column = assortment.find((d) => d.key === dimension);

          let icons: any = source.values
            .filter((value) => value.key === `${dimension} x ${grammage}`)
            .map((value) => ({ ...value, grammage }));

          if (!icons.length) {
            icons = [{ key: `${dimension} x ${grammage}`, grammage, value: [] }];
          }

          if (column) {
            column.values = [...column.values, ...icons];
          } else {
            assortment.push({
              key: dimension,
              values: icons,
            });
          }
        });
      });
      return { assortment, grammages: source.grammages, dimensions: source.dimensions };
    }
    return target;
  }
}
